import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import withTracking from 'tracking/withTracking';

export default withTracking(({ analytics, ...props }) => {
    useEffect(() => {
        analytics.trackPageView(props.location.pathname);
    }, [analytics, props.location.pathname]);

    return <Route {...props} />;
});
